import { Component, Injector, OnInit } from '@angular/core';
import { LogService, PopUpService, StyleService, TemplateService } from '../../services';
import { take, takeUntil } from 'rxjs';
import { Background, MainTemplate } from '../../models';
import { BaseComponent } from '../../components';
import { ProfileService } from '../../services/profile.service';
import { DataPointService } from '../../services/data-point.service';
import { LogSource, LogType } from '../../models/common';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent extends BaseComponent implements OnInit {
  public mainTemplate: MainTemplate;
  private selectTabIndex = 0;
  private pageLinkIndex = 0;

  public getValueBySecondaryDataPoint = ({
    secondaryDataPoint,
    secondarySuffix,
    secondaryPrefix,
  }: any): string =>
    `${
      secondaryPrefix ?? ''
    }${this.dataPointService.getValueByDataPointProperty(secondaryDataPoint)}${
      secondarySuffix ?? ''
    }`;
  public getValueByDataPoint = ({ dataPoint, suffix, prefix }: any): string =>
    `${prefix ?? ''}${this.dataPointService.getValueByDataPointProperty(
      dataPoint
    )}${suffix ?? ''}`;

  constructor(
    public readonly styleService: StyleService,
    private readonly templateService: TemplateService,
    private readonly logService: LogService,
    private dataPointService: DataPointService,
    private popupService: PopUpService,
    injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {    
    this.templateService
      .templateData$()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (template) => {
          this.mainTemplate = template;

          const welcomePopUp = this.mainTemplate.template.welcomeMessage.welcomePopUp;

          this.popupService.checkPopUp(
            welcomePopUp,
            this.pageLinkIndex,
            this.selectTabIndex,
            true
          );
        },
        error: (err) => {
          this.logService.writeLog(JSON.stringify(err), LogType.ERROR, LogSource.SYSTEM);
        },
      });
  }

  public getTierBackground(): [any, any, any] {
    const activeTiers = this.templateService.getActiveTiers(
      this.mainTemplate,
      this.mainTemplate.tierLevels.tiers
    );

    return [
      activeTiers?.activeTier?.additionalBackground,
      activeTiers?.activeTier?.background,
      { color: this.mainTemplate.globalVariables.backgroundSecondary.color },
    ];
  }
}